import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { setDeviceInCookies } from "../constants/setDeviceInCookies";
import { initiateLoginWithOTP } from "../redux/auth";
import { Link } from "react-router-dom";
import Spinner from "../components/Spinner";
import checkUserAllowed from "../../utils/checkUserAllowed";
import Button from "../components/buttons/Button";
import Footer from "../components/Footer";
import Header from "../components/Header";
import "../components/styles/auth.scss";
import { COOKIES } from "../../utils/constants";

const SignInPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoading, redirectTo } = useSelector((state) => state.auth);

  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const spinnerTitle = "Dashboard";
  const user_info = COOKIES.get("user_info");

  useEffect(() => {
    // Check if user is authenticated
    if (user_info) {
      navigate("/");
    }
  }, [user_info, navigate]);

  useEffect(() => {
    // Check if network operator is selected, if not redirect to select-network
    if (!localStorage.getItem("afri_selected_operator")) {
      navigate("/select-network", { state: { from: "/signin" } });
      return;
    }

    setMobileNumber(localStorage.getItem("afri_mobile_number") || "");
  }, [navigate]);

  const _initLoginWithOTP = async () => {
    await initiateLoginWithOTP(true, mobileNumber, email, password, navigate);
  };

  const handleChangeNetwork = () => {
    // Clear the selected operator from localStorage
    localStorage.removeItem("afri_selected_operator");
    // Navigate to select-network page
    navigate("/select-network", { state: { from: "/signin" } });
  };

  const handleMobileNumberInput = (e) => {
    const text = e.target.value;
    const limit = 10;
    // Remove any spaces from the input
    const cleanedText = text.replace(/\s/g, "");
    if (isNaN(Number(cleanedText))) return;
    setMobileNumber(cleanedText.slice(0, limit));
  };

  const handleKeyDown = (e) => {
    // Prevent space key from being typed
    if (e.key === " " || e.keyCode === 32) {
      e.preventDefault();
    }
  };

  const handlePasswordInput = (e) => {
    setPassword(e.target.value);
  };

  useEffect(() => {
    setDeviceInCookies();
    checkUserAllowed();
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header links={1} signin={5} />
      <main>
        <wc-toast></wc-toast>
        {isLoading && <Spinner title={spinnerTitle} />}
        <div className="auth">
          <div className="auth-wrapper">
            <div className="auth-container">
              <div className="form-container">
                <h2>Sign In</h2>
                <div>
                  <input
                    placeholder="eg. 0541234567"
                    value={mobileNumber}
                    onChange={handleMobileNumberInput}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div>
                  <input
                    placeholder="Password"
                    type="password"
                    value={password}
                    onChange={handlePasswordInput}
                    minLength="7"
                    required
                  />
                </div>
                <div className="margin-bottom">
                  <small>
                    Don't have an account?{" "}
                    <Link className="sign-up-link" to="/signup">
                      Sign up
                    </Link>
                  </small>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    userSelect: "none"
                  }}
                >
                  <Button
                    action={_initLoginWithOTP}
                    isLoading={isLoading}
                    isDisabled={isLoading}
                    label="Continue"
                  />
                </div>
                <div className="password-reset-container">
                  <Link className="forgot-password-link" to="/reset-password">
                    Forgot Password?
                  </Link>
                </div>
                <div
                  className="password-reset-container"
                  style={{ marginTop: "10px" }}
                >
                  <span
                    className="change-network-link"
                    onClick={handleChangeNetwork}
                    style={{ cursor: "pointer" }}
                  >
                    Change Network
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default SignInPage;
